<template>
    <div class="data-panel">
        <div class="data-panel-header">
            <h2>{{title}}</h2>
            <a-radio-group v-model="os_name" style="margin:0 0 0 16px; float: right;" v-if="id==='realtime_overview' && ((overview.this && (overview.this.ios || overview.this.android)) || (overview.last && (overview.last.ios || overview.last.android)))">
                <a-radio-button value="all">{{ $t('fixed.all') }}</a-radio-button>
                <a-radio-button value="ios">iOS</a-radio-button>
                <a-radio-button value="android">{{ $t('fixed.android') }}</a-radio-button>
            </a-radio-group>
        </div>
        <!-- 数据概览-数据模块 -->
        <div class="data-panel-content overview-panel-content">
            <div class="data-panel-content-block overview_block data-panel-module" 
                v-for="(field, index) in fields" :key="`overview_${field.id}`"
                :class="{'selected':index==selected}" @click="selected=index"
                :style="{width:`${block_width}%`}" 
            >
                <div class="title">{{$t(field.title)}}
                    <a-tooltip v-if="field.tooltip && field.tooltip($service.PROJ_CODE)">
                        <template slot="title">
                            <span>{{field.tooltip($service.PROJ_CODE) }}</span>
                        </template>
                        <span style="color:#b4b6b7"><a-icon type="info-circle" /></span>
                    </a-tooltip>
                </div>
                <template v-if="id==='realtime_overview'">
                    <div class="day today">
                        <span class="date">{{dt?dt.this:conf.realtime?$t('common.today'):$t('common.yesterdayT')}}</span>
                        <h2 v-if="overview.this[os_name]!=null && overview.this[os_name][field.id]!=null">{{overview.this[os_name][field.id] | format(field.decimal)}}{{field.suffix}}</h2>
                        <h2 v-else class="data_computed">{{$t('fixed.noData')}}</h2>
                    </div>
                    <div class="day yesterday">
                        <span class="date">{{dt?dt.last:conf.realtime?$t('common.yesterdayT'):$t('common.2DaysAgoT')}}</span>
                        <h2 v-if="overview.last[os_name]!=null && overview.last[os_name][field.id]!=null">{{overview.last[os_name][field.id] | format(field.decimal)}}{{field.suffix}}</h2>
                        <h2 v-else class="data_computed">{{$t('fixed.noData')}}</h2>
                    </div>
                </template>
                <template v-else>
                    <div class="day today">
                        <span class="date">{{dt?dt.this:conf.realtime?$t('common.today'):$t('common.yesterdayT')}}</span>
                        <h2 v-if="overview.this[field.id]!=null">{{overview.this[field.id] | format(field.decimal)}}{{field.suffix}}</h2>
                        <h2 v-else class="data_computed">{{$t('fixed.noData')}}</h2>
                        <span class="per" v-if="overview.per && overview.per[field.id]">
                            <a-icon type="caret-up" style="color:#f5222d" v-if="overview.per[field.id]>0" />
                            <a-icon type="caret-down"  style="color:#90d86c" v-else />
                            {{overview.per[field.id]>0?overview.per[field.id]:-overview.per[field.id]}}%
                        </span>
                    </div>
                    <div class="day yesterday">
                        <span class="date">{{dt?dt.last:conf.realtime?$t('common.yesterdayT'):$t('common.2DaysAgoT')}}</span>
                        <h2 v-if="overview.last[field.id]!=null">{{overview.last[field.id] | format(field.decimal)}}{{field.suffix}}</h2>
                        <h2 v-else class="data_computed">{{$t('fixed.noData')}}</h2>
                    </div>
                </template>
            </div>
            <div class="overview_block_selected" :style="{width:`${block_width}%`, left:`${selected*block_width}%`}"></div>
        </div>
        <div class="data-panel-chart open" style="height:auto; padding-bottom:20px;">
            <div class="op_bar">
                <template v-if="display === 'table'">
                    <a-button @click="exportToExcel('overview_table', `${$service.PROJ_CODE}-${title}-${date_range[0].format('YYYY-MM-DD')}-${date_range[1].format('YYYY-MM-DD')}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                    <a-button @click="copy('overview_table')" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                </template>
                <server :single="true" style="display:inline-block; width:auto; margin:0 8px 0 0;" v-model="server" v-if="conf.server"/>
                <a-range-picker class="date_range_picker" v-model="date_range" :allowClear="false" v-if="$service.PROJ_CODE!='l28'"/>
                <RangePicker class="date_range_picker" v-model="date_range" :defaultValue="date_range" v-else style="width:300px; display: inline-block;"/>
                <a-radio-group v-model="display" style="margin:0 0 0 16px;">
                    <a-radio-button value="chart">{{ $t('common.chart') }}</a-radio-button>
                    <a-radio-button value="table">{{ $t('common.table') }}</a-radio-button>
                </a-radio-group>
            </div>
            <a-spin :spinning="loading" :tip="$t('fixed.loading')" class="loading" >
                <chart :datas="chart_datas" :conf="chart_conf" :height="350"  :fields="chart_fields" class="fixed-chart" :class="{hidepanel:display!=='chart'}"/>
                <data-table :fields="chart_fields" :datas="table_datas" ref="overview_table"  class="fixed-datatable" :class="{hidepanel:display!=='table'}"/>
            </a-spin>
        </div>
    </div>
</template>

<script>
import moment from "moment"

import Server from '@/components/common/search/server.vue'
import Chart from '@/components/common/chart/chart.vue'
import DataTable from '@/components/common/datatable.vue'
import {weekday, versionDurationDays} from '@/utils/utils'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'
import RangePicker from "@/components/common/search/range_picker.vue";

import {Tooltip} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Tooltip)

export default {
    name: 'overviewPanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    components: {
        Chart, DataTable, Server, RangePicker
    },
    props: {
        id: String,
        // 数据接口
        api: {
            type: String,
        },
        // 标题
        title: {
            type: String,
            default: "数据概览",
        },
        // 字段
        fields: {
            type: Array,
            default: ()=>{return []},
        },
        // 其他配置条件
        conf: {
            type: Object,
            default: ()=>{return {}},
        },
        searchers: {
            type: Object,
            default: ()=>{return {}},
        }
    },
    data() {
        return {
            loading: true,
            dt: null,
            selected: this.conf.selected>=0?this.conf.selected:0,
            // 概览数据
            overview: {
                this: {},
                last: {},
                per: {},
            },
            display: 'chart',
            os_name: 'all',
            date_range: [],
            server: null,
            // 用于表
            table_datas: [],
            // 用于图
            chart_datas: [],
            chart_conf: {
                fixed: true,
                versionday: 'dt',
                type: 'line',
                shape: 'splitLine',
                x: {id: 'ds', title: this.$t('common.date')},
                y: {id: 'dau'},
                color: (series)=>{return series.indexOf(this.$t('common.monthPeriod'))>=0?'#FFAE28':series.indexOf(this.$t('common.yearPeriod'))>=0?'#2FC25B':series==this.$t('common.currentPeriod')?'#1890FF':'rgba(0,0,0,0)'},
                series: {id:'series'},
                label: false,
                slider: true,
                mark: true,
                other: {
                    legend: {
                        position: 'top-center',
                        reversed: true,
                    }
                }
            },
        }
    },
    watch: {
        selected(newV) {
            let selected = newV>=0?newV:0
            this.$nextTick(()=>{
                if(this.os_name==='all') {
                    this.chart_conf.y = {...this.fields[selected], title: this.$t(this.fields[selected].title)}
                }
                else {
                    this.chart_conf.y = {...this.fields[selected], id:`${this.os_name}_${this.fields[selected].id}`, title: this.$t(this.fields[selected].title)}
                }
            })
        },
        // 选择时间
        date_range(newV) {
            if(newV && newV.length>=2) {
                this.getOverviewChart()
            }
        },
        // 选择服务器
        server(newV) {
            this.getOverviewChart()
        },
    },
    computed: {
        chart_fields() {
            if(this.os_name==='all') {
                this.chart_conf.y = {...this.fields[this.selected], title: this.$t(this.fields[this.selected].title)}
                const _fields = [{id:'dt', title:this.$t('common.date'),},].concat(this.fields)
                return _fields.map(f=>({...f, title: this.$t(f.title)}))
            }
            else {
                this.chart_conf.y = {...this.fields[this.selected], id:`${this.os_name}_${this.fields[this.selected].id}`, title: this.$t(this.fields[this.selected].title) }
                
                const _fields = [{id:'dt', title:this.$t('common.date'),},...this.fields.map(f=>({...f, id:`${this.os_name}_${f.id}`}))]
                return _fields.map(f=>({...f, title: this.$t(f.title)}))
            }
        },
        block_width() {
            return this.fields.length>0?100/this.fields.length:100
        },
        game_info() {
            return this.$store.state.game.info;
        }
    },
    methods: {
        initDate() {
            // 处理时间
            console.log()
            if(this.searchers.date_range && this.searchers.date_range.default) {
                this.date_range = [moment(this.searchers.date_range.default[0]), moment(this.searchers.date_range.default[1])]
            }
            else {
                if(this.conf.realtime) {
                    let month_ago = moment(this.today).subtract(27, 'day');
                    this.date_range = [month_ago, this.today]
                }
                else {
                    let month_ago = moment(this.yesterday).subtract(27, 'day');
                    this.date_range = [month_ago, this.yesterday]
                }
            }
        },
        // 获取数据概览数据
        getOverview() {
            if(this.api) {
                const params = this.searchers?.date_range?.default?{dt:this.searchers.date_range.default[1]}:{}
                this.$service.query_fixed_module(this.api, params).then((data)=>{
                    if(params.dt) {
                        this.dt = {
                            this: params.dt,
                            last: moment(params.dt).subtract(1, 'day').format('YYYY-MM-DD')
                        }
                    }
                    this.overview = data
                })
            }
        },
        // 获取数据概览图表数据
        getOverviewChart() {
            if(this.date_range.length < 2) 
                return
            this.loading = true
            // 日期处理部分
            let today = moment().format('YYYY-MM-DD')
            // 本期
            let start_dt = this.date_range[0].format('YYYY-MM-DD')
            let end_dt = this.date_range[1].format('YYYY-MM-DD')
            let days = this.date_range[1].diff(this.date_range[0], 'day')

            // 环比
            let last_end_dt = moment(start_dt).subtract(1, 'day').format('YYYY-MM-DD')
            let last_start_dt = moment(last_end_dt).subtract(days, 'day').format('YYYY-MM-DD')

            let current_index = 0

            let params = [
                
            ]
            // 预测
            let predict_index = null
            if(this.conf.realtime && today<=end_dt && today>=start_dt) {
                params.push({start_dt:start_dt, end_dt:today, predict: true, series:''},)
                predict_index = params.length-1
            }

            // 本期
            params.push({start_dt, end_dt, predict: false, series:this.$t('common.currentPeriod'), server:this.server},)
            current_index = params.length-1

            // 12-08: l10 有同比和环比，同比环比的计算方式为版本对齐
            if(this.$service.PROJ_CODE.indexOf('l10') >= 0) {
                const versionDays = (this.game_info && this.game_info.new_version_days) ? this.game_info.new_version_days : {};
                console.log(versionDays)
                // 环比
                const lastDuration = versionDurationDays(start_dt, days, last_start_dt, versionDays);
                const fixed_last_start_dt = moment(last_start_dt).add(lastDuration, 'day').format('YYYY-MM-DD');
                const fixed_last_end_dt = moment(last_end_dt).add(lastDuration, 'day').format('YYYY-MM-DD');
                params.push({start_dt: fixed_last_start_dt, end_dt:fixed_last_end_dt, predict: false, series:`${this.$t('common.monthPeriod')}（${fixed_last_start_dt}~${fixed_last_end_dt}）`, server:this.server})
                
                // 同比
                let year_start_dt = moment(start_dt).subtract(1, 'years').format('YYYY-MM-DD')
                let year_end_dt = moment(year_start_dt).add(days, 'day').format('YYYY-MM-DD')
                const yearDuration = versionDurationDays(start_dt, days, year_start_dt, versionDays);
                const fixed_year_start_dt = moment(year_start_dt).add(yearDuration, 'day').format('YYYY-MM-DD');
                const fixed_year_end_dt = moment(year_end_dt).add(yearDuration, 'day').format('YYYY-MM-DD');
                params.push({start_dt:fixed_year_start_dt, end_dt:fixed_year_end_dt, predict: false, series:`${this.$t('common.yearPeriod')}（${fixed_year_start_dt}~${fixed_year_end_dt}）`, server:this.server},)
            } 
            else if(this.$service.PROJ_CODE.indexOf('l22') >= 0) {
                const versionDays = {};
                let _today = moment()
                let _day =  moment('2024-07-25')
                while(_today.isAfter(_day)) {
                    if(_day.weekday()===3) {
                        versionDays[_day.format('YYYY-MM-DD')] = 1
                    }
                    _day.add(1, 'day')
                }
                // 环比
                const lastDuration = versionDurationDays(start_dt, days, last_start_dt, versionDays);
                const fixed_last_start_dt = moment(last_start_dt).add(lastDuration, 'day').format('YYYY-MM-DD');
                const fixed_last_end_dt = moment(last_end_dt).add(lastDuration, 'day').format('YYYY-MM-DD');
                params.push({start_dt: fixed_last_start_dt, end_dt:fixed_last_end_dt, predict: false, series:`${this.$t('common.monthPeriod')}（${fixed_last_start_dt}~${fixed_last_end_dt}）`, server:this.server})
            } 
            else {
                // 环比
                params.push({start_dt: last_start_dt, end_dt:last_end_dt, predict: false, series:`${this.$t('common.monthPeriod')}（${last_start_dt}~${last_end_dt}）`, server:this.server})
            }
            

            this.$service.query_fixed_module(`${this.api}_chart`, {ranges:params, os_name: this.os_name}).then((datas) => {
                let chart_datas, table_datas, combine_dates
                [chart_datas, table_datas, combine_dates] = [[], [], {}]
                let has_predict = this.conf.realtime && predict_index!=null && Array.isArray(datas[predict_index]) && datas[predict_index].length !== 0  && datas[current_index].length >= 2
                // 处理预测线数据
                if(has_predict) {
                    // 预测点
                    let row = datas[predict_index].pop()
                    row.is_predict = true
                    row.mark = '[预测]'
                    
                    datas[predict_index] = [Object.assign({series_visible:false}, datas[current_index][datas[current_index].length-2]), Object.assign({series_visible:false}, row)]
                    datas[current_index][datas[current_index].length-1].mark='[实时]'
                    datas[current_index].push(Object.assign({}, row))
                } 
                for(let series=datas.length-1; series>=0; series--) {
                    datas[series].forEach((row, r_index)=>{
                        row['series'] = params[series].series
                        let day = series===current_index || series===predict_index?moment(row['dt']):moment(start_dt).add(row.day, 'days')
                        row['ds'] = day.format('YYYY-MM-DD')
                        row['weekday'] = this.$t(`week.short_${day.weekday()+1}`)
                        row['dt_weekday'] = this.$t(`week.short_${moment(row['dt']).weekday()+1}`)
                        // console.log(row)
                        if(!combine_dates[row.dt] && (!this.conf.realtime || series!==predict_index)) {
                            combine_dates[row.dt] = 1
                            table_datas.push(row)
                        }
                        this.fields.forEach((e) => {
                            row[`${e.id}_updown`] = r_index > 0 ? (datas[series][r_index-1][e.id] === 0 || datas[series][r_index-1][e.id] == null) ? '-' : Math.floor(((row[e.id] - datas[series][r_index-1][e.id]) / datas[series][r_index-1][e.id]) * 10000) / 100 : '-'
                        })
                        if(series!==predict_index || r_index!==0) {
                            chart_datas.push(row)
                        }
                    })
                }
                this.table_datas = _.orderBy(table_datas, ['dt'], ['desc'])
                this.chart_datas = chart_datas
                this.loading = false
            }).catch((errors)=>{
                console.log(errors)
                this.loading = false
            })
        },
    },
    mounted() {
        const selected = this.conf.selected>=0?this.conf.selected:0
        this.chart_conf.y = {...this.fields[selected], title:this.$t(this.fields[selected].title)}
        
        this.initDate()
        this.getOverview()
    }
}
</script>